<template>
  <div>
    <div class="column is-narrow pdr-0 is-pulled-left mgt-10px pdl-0">
      <button class="button" @click="switchDate(-1)">
        <b-icon icon="chevron-left" size="is-small" type="is-default">
        </b-icon>
      </button>
    </div>
    <div class="column is-narrow is-pulled-left mgt-10px pdl-5px pdr-0">
      <b-datepicker show-week-number
                    nearby-selectable-month-days
                    icon="calendar-today"
                    v-model="dateStart"
                    :editable="true">
      </b-datepicker>
    </div>
    <div class="column is-narrow is-pulled-left mgt-10px pdl-5px pdr-0">
      <button class="button" @click="switchDate(1)">
        <b-icon icon="chevron-right" size="is-small" type="is-default"></b-icon>
      </button>
    </div>
  </div>
</template>

<script>

import moment from 'moment/moment';

export default {
  name: 'jumpWeekDatePicker',
  props: {
    value: {
      required: true,
      type: Date,
    },
    nbJourASauter: {
      required: true,
      type: Number,
    },
  },
  computed: {
    dateStart: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    switchDate(sens) {
      if (!this.dateStart) return;
      this.dateStart = (moment(this.dateStart).add(this.nbJourASauter * sens, 'days')).toDate();
    },
  },
};

</script>
